<template>
  <div>
    <v-navigation-drawer
      ref="globalNavDrawer"
      id="globalNav"
      class="global-nav-drawer"
      v-model="drawer"
      app
      clipped
      :width="globalNavDrawerWidth"
    >
      <!--
      showExplorer의 초기값은 true이다. => showExplorer = true
      1. 리스트 항목 클릭시 API를 호출하고 리스트가 있다면 showExplorer를 false로 한다. => showExplorer = false
      2. 닫기 버튼을 생성하고 클릭시 showExplorer를 true로 하여 image-explorer는 닫는다. => showExplorer = true
      3. 다시 image-explorer를 보고 싶다면 리스트의 항목을 클릭한다.
     -->
      <template>
        <div v-show="getShowExplorer" class="sidebar_list" style="top: 60px">
          <v-list-item
            class="px-2"
            style="
              position: sticky;
              top: 0;
              z-index: 5;
              background-color: var(--navBgColor);
            "
          >
            <v-list-item-title>
              <!--						{{reportName}}-->
              <v-col
                cols="12"
                sm="60"
                md="30"
                style="position: sticky"
              >
                <v-text-field
                  v-model="keyword"
                  :disabled="!isRendered"
                  :label="$t('project.searchBySite')"
                  outlined
                  class="textfield"
                  hide-details
                  clearable
                  clear-icon="mdi-close-circle-outline"
                />
              </v-col>
            </v-list-item-title>
          </v-list-item>

          <v-divider />
          <!-- 사이드바 list -->
          <!-- color="secondary" 폰트색 -->
          <template v-if="!getDashboardLoading">
            <v-list-group
              v-for="p in localProjects"
              :key="`${p.id}_${isActive(p.id, '', '', '')}`"
              no-action
              :data-testid="`${p.id}_${isActive(p.id, '', '', '')}`"
              prepend-icon=""
              :value="isActive(p.id, '', '', '')"
              @click.stop.prevent="
                toggleActive({
                  projectId: p.id,
                  siteId: '',
                  dayName: '',
                  reportId: '',
                })
              "
            >
              <!-- prepend-icon="mdi-account-circle" -->
              <template slot="activator">
                <v-list-item-icon>
                  <v-icon>mdi-projector-screen-outline</v-icon>
                </v-list-item-icon>
                <v-list-item-title>{{ p.name }}</v-list-item-title>
              </template>
              <!-- 상위그룹 -->

              <v-list-group
                v-for="s in p.children"
                :key="`${s.id}_${isActive('', s.id, '', '')}`"
                class="list_area"
                no-action
                sub-group
                :data-testid="`${s.id}_${isActive('', s.id, '', '')}`"
                prepend-icon=""
                :value="isActive('', s.id, '', '')"
                @click.stop.prevent="selectSite(s)"
              >
                <!--  -->
                <!-- 지역 폴더 -->
                <template slot="activator">
                  <v-list-item-icon>
                    <v-icon>mdi-solar-panel</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content class="location_list">
                    <v-list-item-title>{{ s.name }}</v-list-item-title>
                  </v-list-item-content>
                  <v-list-item-icon v-if="isActive('', s.id, '', '')">
                    <v-icon>mdi-chevron-down</v-icon>
                  </v-list-item-icon>
                  <v-list-item-icon v-if="!isActive('', s.id, '', '')">
                    <v-icon>mdi-chevron-up</v-icon>
                  </v-list-item-icon>
                </template>

                <!-- 날짜 그룹 -->
                <v-list-group
                  v-for="d in s.children"
                  :key="`${s.id}_${d.name}_${isActive('', s.id, d.name, '')}`"
                  class="list_day"
                  sub-group
                  no-action
                  :data-testid="`${s.id}_${d.name}_${isActive(
                    '',
                    s.id,
                    d.name,
                    ''
                  )}`"
                  prepend-icon=""
                  :value="isActive('', s.id, d.name, '')"
                  @click.stop.prevent="
                    toggleActive({
                      projectId: '',
                      siteId: s.id,
                      dayName: d.name,
                      reportId: '',
                    })
                  "
                >
                  <template slot="activator">
                    <v-list-item-icon>
                      <v-icon>mdi-calendar-search-outline</v-icon>
                    </v-list-item-icon>
                    <v-list-item-content class="day_listfolder">
                      <v-list-item-title>{{ d.name }}</v-list-item-title>
                    </v-list-item-content>
                    <v-list-item-icon v-if="isActive('', s.id, '', '')">
                      <v-icon>mdi-chevron-down</v-icon>
                    </v-list-item-icon>
                    <v-list-item-icon v-if="!isActive('', s.id, '', '')">
                      <v-icon>mdi-chevron-up</v-icon>
                    </v-list-item-icon>
                  </template>
                  <v-list-item-group>
                    <v-list-item
                      v-for="(r, ri) in d.children"
                      :key="ri"
                      :data-testid="`${s.id}_${d.name}_${r.id}_${isActive(
                        '',
                        s.id,
                        d.name,
                        r.id
                      )}`"
                      link
                      :class="{ openFolder: r === getReportId }"
                      @click.stop.prevent="clickItem(s, r)"
                    >
                      <v-progress-linear
                        v-show="loading && r === tempSelectedReport"
                        indeterminate
                        style="position: absolute; bottom: 0; left: 0"
                      />
                      <v-list-item-title>{{ r.name }}</v-list-item-title>
                    </v-list-item>
                  </v-list-item-group>
                </v-list-group>
              </v-list-group>
            </v-list-group>
          </template>
          <div
            v-else
            style="width: 100%; height: calc(100vh - 260px); overflow: hidden"
          >
            <RailListSkeleton variant="tree-row" :count="12" root-class="px-2" />
          </div>
        </div>
      </template>

      <template>
        <div v-show="!getShowExplorer" style="width: 100%; height: 100%">
          <div
            class="d-flex flex-column w-full h-full"
            style="width: 100%; height: 100%"
          >
            <v-card
              ref="stickyCard"
              flat
              color="transparent"
              class="d-flex justify-space-between flex-shrink-0 solvit-rail-subheader"
            >
              <v-card
                class="ma-3"
                tile
                flat
                color="transparent"
                style="margin-right: 0 !important"
              >
                {{ getSiteName }} > {{ getReportName }}
              </v-card>
              <v-btn class="ma-2" icon @click.stop="closeReportShow">
                <BackArrowIcon />
              </v-btn>
            </v-card>

            <ImageExplorer
              :loading="loading"
              class="d-flex"
              style="width: 100%; height: 100%"
              :images="thermalImages"
            />
          </div>
        </div>
      </template>

      <!-- <template v-slot:append>
      <v-list dense style="border-top: 1px solid rgba(0, 0, 0, 0.5)">
        <v-list-item
          to="/admin/project"
          :disabled="userProfile?.userRole !== 'ADMIN'"
        >
          <v-list-item-action>
            <v-icon color="secondary darken-0">mdi-cog-outline</v-icon>
          </v-list-item-action>
          <v-list-item-title class="secondary--text text--darken-0"
            >Settings</v-list-item-title
          >
        </v-list-item>
      </v-list>
    </template>
    -->
    </v-navigation-drawer>
    <!-- <v-btn
      id="hamburgerBtn"
      @click="drawer = !drawer"
      v-bind:style="{ left: drawer ? '330px' : '0px' }"
      v-model="hamburgerBtn"
      ><v-icon>mdi-chevron-double-right</v-icon>
    </v-btn> -->
  </div>
</template>

<script>
// import 'src\assets\css\styles\style.scss'
// import '@/assets/css/style.scss';
// import { objectToQuery } from "cesium";
// import Color from "cesium/Source/Core/Color";
// import { clear } from "console";
// import { click } from "ol/events/condition";
// import { Style } from "ol/style";
import api from '@/apis/Api';
import { mapGetters, mapActions } from 'vuex';
import { globalNavDrawerResizeMixin } from '@/ui/mixins/globalNavDrawerResizeMixin.js';
import { appPerfMark, appPerfMeasure, appPerfSinceMyProfile } from '@/utils/appBootstrapPerfLog.js';
// import { ExamineOutputService } from "../../_services";
export default {
  mixins: [globalNavDrawerResizeMixin],
  components: {
    RailListSkeleton: () => import('../common/RailListSkeleton.vue'),
    ImageExplorer: () =>
      import(/* webpackChunkName: "image-explorer" */ '../../components/card/ImageExplorer'),
    BackArrowIcon: () => import('../common/BackArrowIcon')
  },
  props: ['d.children'],
  data: () => ({
    //검색시 랜더링완료전에 프로젝트검색시에 랜더링과정과 겹쳐져서 list가 전체 리스트가 표현되는 문제
    isRendered: true,
    // r: undefined,

    // images: [], // all images
    test: false,
    image: undefined, //selected image,
    layer: '',
    // thermalImages: [],
    drawer: true,
    iconTypes: {
      Project: 'mdi-folder',
      Site: 'mdi-antenna',
      SolarExamineReport: 'mdi-solar-panel'
    },
    open: [1, 2],
    search: null,
    keyword: undefined,
    localProjects: [],
    loading: false,
    tempSelectedReport: null
  }),
  computed: {
    ...mapGetters({ userProfile: 'user/getUserProfile' }),
    ...mapGetters({ thermalImages: 'dashboard/getThermalImages' }),
    ...mapGetters({ projects: 'dashboard/projects' }),
    ...mapGetters({ isActive: 'explorer/isActive' }),
    ...mapGetters({ getReportId: 'explorer/getReportId' }),
    ...mapGetters({ getSiteName: 'explorer/getSiteName' }),
    ...mapGetters({ getReportName: 'explorer/getReportName' }),
    ...mapGetters({ getShowExplorer: 'explorer/getShowExplorer' }),
    ...mapGetters({ getSite: 'explorer/getSite' }),
    ...mapGetters({ getDashboardLoading: 'dashboard/getDashboardLoading' })
  },

  watch: {
    // drawer: {
    //   handler: function (val) {
    //     console.log(this.$refs.navigationDrawer.next);
    //     this.$refs.navigationDrawer.nextSibling.style.left = val;
    //     if (val) {
    //       this.$refs.hamburgerBtn.style.left = "330px";
    //     } else this.$refs.hamburgerBtn.style.left = "0px";
    //   },
    //   immediate: true,
    // },
    //여기서는 온도 데이터가 바뀌면 탐색기 열리도록 설정 -> api로 fetch 한다음 랜더링하는데 시간이 걸림-> fetch 비동기로 처리하는 것이 적절하지 않음
    //-> 랜더링 다음에 페이지 변경이 적절함
    //->랜더링 이전에는 loading 처리 (지도 map 부분에 처리하는게 적절할듯)
    //->랜더링 이후를 감지 -> thermalImages로 해야하긴함 -> 모든 경우에 thermalImages가 바뀌는건 아님
    //-> 변경되지 않아도 탐색기가 열려야함 -> api로 fetch하지않는경우 termalImage로 처리하지 않고 바로 처리 ->
    thermalImages: {
      //객체이므로 deep사용필요
      // dashboard.store가 초기화 되면서 length가 0인 이미지가 배열이 넘어온다.
      handler: function (newImages) {
        if (newImages && newImages?.length > 0) {
          this.setShowExplorer(false);
        }
      },
      deep: true
    },

    keyword: async function (keyword) {
      const res = await this.searchProjects(keyword);
      this.localProjects = res;
    },
    projects: {
      handler: function (projects) {
        this.$set(this, 'localProjects', projects);
        this.$forceUpdate();
      },
      immediate: true,
      deep: true
    },
    getReportId: function () {
      // Report 변경 시 사각형 초기화는 explorerStore에서 자동으로 처리됨
    }
  },

  methods: {
    ...mapActions({
      searchProjects: 'dashboard/searchProjects',
      toggleActive: 'explorer/toggleActive',
      setReportName: 'explorer/setReportName',
      selectTreeItem: 'explorer/selectTreeItem',
      setShowExplorer: 'explorer/setShowExplorer',
      setMapMenu: 'explorer/setMapMenu',
      setSiteName: 'explorer/setSiteName',
      selectSite: 'explorer/selectSite'
    }),

    handleOpenDefectWindowEvent() {
      //하위컴포넌트에서 실행...
    },
    onToggleDrawerEvent({ from }) {
      if (from === 'HeaderBar') {
        this.drawer = !this.drawer;
      }
    },
    closeReportShow() {
      this.setReportName('');
      if (this.getReportId) {
        this.toggleActive({
          projectId: '',
          siteId: '',
          dayName: '',
          reportId: this.getReportId
        });
      }
      //지도의 메뉴닫기
      this.setMapMenu(false);
      //report 탐색기 닫기
      this.setShowExplorer(true);
    },
    async clickItem(s, r) {
      this.loading = true;
      this.tempSelectedReport = r;
      await this.selectTreeItem({ site: s, item: r });
      this.loading = false;
    }
    //p:project, s:site,d:day, r:report
    // getThermalImages(reportSeq) {
    //   ExamineOutputService.getThermalImages(reportSeq)
    //     .then((data) => {
    //       this.thermalImages = data;

    //       /**
    //        * 정보를 가져왔을 때 사이드 메뉴를 토글해서 태양광패널리스트가 보여지도록 한다.
    //        * 만약 태양광 패널이 존재할 때만 보여주고싶다면 this.showExplorer를 조건으로 걸어주면 된다.
    //        * !this.showExplorer는 현재값에 반대되는 값을 보여주도록 하기 위함이며,
    //        * getThermalImages 가 동작하는 순간은 리스트를 클릭시 동작하므로 언제나 this.showExplorer가 true인 상태가 된다.
    //        * 따라서 다음고 같이 값을 할당한다.
    //        *  */
    //       this.showExplorer = !this.showExplorer;
    //     })
    //     .catch((error) => {
    //     });
    // },
  },

  created() {
    this.$eventBus.$on('toggle-drawer', this.onToggleDrawerEvent);
  },
  beforeUnmount() {
    this.$eventBus.$off('toggle-drawer', this.onToggleDrawerEvent);
  },
  /**
   * 처음 페이지 접속시에 globalNav가 탐색기를 보여줄지 report부분을 보여줄지 결정
   */
  async mounted() {
    appPerfMark('CoreLeftDrawer:mounted', {
      siteId: this.getSite?.id,
      reportId: this.getReportId,
      dashboardLoading: this.getDashboardLoading
    });
    appPerfSinceMyProfile('CoreLeftDrawer:mounted');
    // addEventListener("open-defect-window", this.handleOpenDefectWindowEvent);
    //보고서 탐색기 열고 닫기
    try {
      this.isRendered = false;
      if (this.getSite?.id == null || this.getReportId == null) {
        appPerfMark('CoreLeftDrawer:skipRestore', { reason: 'no persisted site/report' });
        this.setShowExplorer(true);
        return;
      }
      //api 호출전에 로딩처리
      this.loading = true;
      appPerfMark('CoreLeftDrawer:restoreApis:start', {
        siteId: this.getSite?.id,
        reportId: this.getReportId
      });
      // 두 API 호출을 병렬로 진행 완료 후  selectTreeItem 함수의 순차적으로 진행(여기서도 api 있음)
      const [siteResp, reportResp] = await Promise.all([
        api.read(`/sites/${this.getSite?.id}`),
        api.read(`/solarExamineReports/${this.getReportId}`)
      ]);
      appPerfMeasure('CoreLeftDrawer:restoreApis:done', 'CoreLeftDrawer:restoreApis:start', {
        siteStatus: siteResp?.status,
        reportStatus: reportResp?.status
      });
      this.tempSelectedReport = reportResp?.data;
      appPerfMark('CoreLeftDrawer:selectTreeItem:start');
      await this.selectTreeItem({
        site: siteResp?.data?.content,
        item: reportResp?.data,
        preloadedReport: reportResp?.data
      });
      appPerfMeasure('CoreLeftDrawer:selectTreeItem:done', 'CoreLeftDrawer:selectTreeItem:start');
      appPerfSinceMyProfile('CoreLeftDrawer:restoreComplete');
      //api 호출후 랜더링
      this.loading = false;

      // selectTreeItem 끝에서 이미 SET_SHOW_EXPLORER(false) 처리됨.
      // thermalImages는 fetch 직후 잠깐 []이거나 0건 보고서일 수 있음 → length만으로 메인(트리)으로
      // 덮어쓰면 다른 페이지 갔다 올 때 ImageExplorer 대신 메인이 보임.
      if (this.getReportId && this.thermalImages.length > 0) {
        this.setShowExplorer(false);
      } else if (!this.getReportId) {
        this.setShowExplorer(true);
      }

    } catch (error) {
      console.error('API 호출 중 에러 발생:', error);
    } finally {
      this.isRendered = true;
      this.$nextTick(() => {
        this.initGlobalNavDrawerResize();
      });
    }
  }
};
</script>

<style scoped>
/* list bar 구분 선 맨 마지막 라인은 주지 않는다. */
/* .list_area{
  padding: 2px 0px 0px 0px;
    border-bottom: 1px solid #DBD0C0;
    font-size: 12px;

} */

.openFolder {
  background-color: var(--v-surface-base);
}

.list_area {
  margin-left: 10px;
}

.list_day {
  padding: 2px 0px 0px 0px;
  font-size: 12px;
  margin-left: 20px;
}
/* 폰트 */
.textfield {
  font-family: Noto Sans KR;
}
.flexCenter {
  display: flex;
  align-items: flex-start;
}
#hamburgerBtn {
  width: 20px;
  height: 150px;
  position: absolute;
  left: 350px;
  height: 65px;
  top: 67px;
  z-index: 4;
  word-break: break-all;
}

#globalNav .v-navigation-drawer__content {
  width: 100%;
  height: 100%;
  overflow: auto;
}
.sidebar_list {
  margin-bottom: 48px;
}
</style>
